export default __webpack_public_path__ + "static/media/austria.a90fd1b7.jpg";